import React from 'react';

export default function DefaultPageFallbackContent({ pageTitle = '' }) {
  return (
    <div className="simple-page-placeholder">
      <p className="simple-page-subtitle">
        The {pageTitle || 'selected'} view is coming soon. Use the sidebar to switch back to Dashboard.
      </p>
    </div>
  );
}
